import { html } from '@design.estate/dees-element';
import { demoPage } from '../../../demos/templates.js';

export const demoFunc = () => demoPage('Usage', 'Compact token counts with detailed totals on hover.', html`
  <div class="usageDemo dees-demo-row">
    <dees-harness-usage
      .usage=${{ inputTokens: 1840, outputTokens: 310, totalTokens: 2150, cacheReadTokens: 1200 }}
    ></dees-harness-usage>
    <dees-harness-usage
      compact
      .usage=${{ inputTokens: 152_000, outputTokens: 9_400, totalTokens: 161_400 }}
    ></dees-harness-usage>
  </div>
`);
